/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/quotes */

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatListModule } from "@angular/material/list";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableModule } from "@angular/material/table";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatPaginatorModule } from "@angular/material/paginator";
import { LoginComponent } from "./login/login.component";
import { MatDialogModule } from "@angular/material/dialog";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ProgressSpinnerComponent } from "./progress-spinner/progress-spinner.component";
import { NgOtpInputModule } from "ng-otp-input";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { DatePipe } from "@angular/common";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatRadioModule } from "@angular/material/radio";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { GoogleChartsModule } from "angular-google-charts";
import { RecaptchaModule } from "ng-recaptcha";
import { HomeComponent } from "./secure/home/home.component";
import { HttpConfigInterceptor } from "./httpconfig.interceptor";
import { DashboardCardComponent } from "./components/dashboard-card/dashboard-card.component";
import { ReportsComponent } from "./secure/reports/reports.component";
import { OrganizationListComponent } from "./secure/master/organization/list/organization-list.component";
import { OrganizationAUComponent } from "./secure/master/organization/au/organization-au.component";
import { RouteReuseStrategy } from "@angular/router";
import { BoardListComponent } from "./secure/master/board/list/board-list.component";
import { BoardAUComponent } from "./secure/master/board/au/board-au.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { RoleListComponent } from "./secure/master/role/list/role-list.component";
import { RoleAUComponent } from "./secure/master/role/au/role-au.component";
import { UserListComponent } from "./secure/master/user/list/user-list.component";
import { UserAUComponent } from "./secure/master/user/au/user-au.component";
import { FieldErrorComponent } from "./components/field-error/field-error.component";
import { DefaultPasswordModalComponent } from "./secure/master/user/au/default-password-modal/default-password-modal.component";
import { FeatureListComponent } from "./secure/master/feature/list/feature-list.component";
import { FeatureAUComponent } from "./secure/master/feature/au/feature-au.component";
import { MatSortModule } from "@angular/material/sort";
import { MatMenuModule } from "@angular/material/menu";
import { MatTabsModule } from "@angular/material/tabs";
import { ChangePasswordComponent } from "./secure/change-password/change-password.component";
import {
  NgxMatDatetimePickerModule,
  NgxMatTimepickerModule,
  NgxMatNativeDateModule,
} from "@angular-material-components/datetime-picker";
import { NgxMatMomentModule } from "@angular-material-components/moment-adapter";
import { AnnouncementListComponent } from "./secure/announcement/list/announcement-list.component";
import { AnnouncementAuComponent } from "./secure/announcement/au/announcement-au.component";

import { ViewPdfComponent } from "./secure/view-pdf/view-pdf.component";
import { PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { LoaderComponent } from "./secure/loader/loader.component";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { QueryExecutorListComponent } from "./secure/query-executor-list/query-executor-list.component";
import { QueryExecutorComponent } from "./secure/query-executor/query-executor.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FullCalendarComponent } from "./full-calendar/full-calendar.component";
import { FullCalendarModule } from '@fullcalendar/angular'; // Import FullCalendarModule
import dayGridPlugin from '@fullcalendar/daygrid'; // Import dayGrid plugin
import interactionPlugin from '@fullcalendar/interaction'; // Import interaction plugin
import { AppointmentRejectComponent } from "./secure/apointment-list/reject-case/appointment-reject-case.component";
import { AppointmentApproveComponent } from "./secure/apointment-list/approve-case/appointment-approve-case.component";
import { ViewApplicantAppoitmentDtlComponent } from "./secure/apointment-list/view/applicant-appointment-dtl.component";
import { apointmentComponent } from "./secure/apointment-list/apointment.component";
import { ForwardAnotherAuthorityComponent } from "./secure/apointment-list/forward-another-authority-case/forward-another-authority-case.component";
import { RescheduledAppointmentComponent } from "./secure/apointment-list/RescheduledAppointment/RescheduledAppointment.component";
import { OpenAppointmentSlot } from "./secure/open-appintment-slot/open-appointment-slot.component";
import { OpenAppointmentTableComponent } from "./secure/open-appintment-slot/table/open-appointment-table.component";
import { AppointmentAuditTrailComponent } from "./secure/appointment-auditTrail/appointmentAudit-trail.component";
import { TimePickerComponent } from "./secure/timePikker/time-picker.component";
import { VisitorDashboardComponent } from "./secure/visitorDashboard/visitorDashboard.component";
import { visitorDashboardcopycopyComponent } from "./secure/visitorDashboardcopycopy/visitorDashboardcopycopy.component";
import { WalkinAppointmentComponent } from "./secure/walkin-appointment/walkin-appointment.component";
import { WebcamModule } from "ngx-webcam";
import { WalkinAppointmentListComponent } from "./secure/walkin-appointment-list/walkin-appointment-list.component";
// import { ForwardedHistoryComponent } from "./secure/apointment-list/forwarded-history/forwarded-history.component";
import { NewvisitorDashboardComponent } from "./secure/NewvisitorDashboard/NewvisitorDashboard.component";


@NgModule({
  declarations: [
    AppComponent,
    SidenavComponent,
    LoginComponent,
    ProgressSpinnerComponent,
    HomeComponent,
    DashboardCardComponent,
    ReportsComponent,
    RoleListComponent,
    RoleAUComponent,
    UserListComponent,
    UserAUComponent,
    OrganizationListComponent,
    OrganizationAUComponent,
    // BoardListComponent,
    // BoardAUComponent
    BoardListComponent,
    BoardAUComponent,
   ReportsComponent,
    FieldErrorComponent,
    DashboardCardComponent,
    DefaultPasswordModalComponent,
    FeatureListComponent,
    FeatureAUComponent,
    ChangePasswordComponent,
    ChangePasswordComponent,
    AnnouncementListComponent,
    AnnouncementAuComponent,
    ViewPdfComponent,
    LoaderComponent,
    QueryExecutorListComponent,
    QueryExecutorComponent,
    QueryExecutorComponent,
    QueryExecutorComponent,
    FullCalendarComponent,
    OpenAppointmentSlot,
    OpenAppointmentTableComponent,
    apointmentComponent,
    ViewApplicantAppoitmentDtlComponent,
    AppointmentRejectComponent,
    AppointmentApproveComponent,
    ForwardAnotherAuthorityComponent,
    RescheduledAppointmentComponent,
    AppointmentAuditTrailComponent,
    TimePickerComponent,
    VisitorDashboardComponent,
    NewvisitorDashboardComponent,
    visitorDashboardcopycopyComponent,
    WalkinAppointmentComponent,
    WalkinAppointmentListComponent,
    // ForwardedHistoryComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatInputModule,
    MatFormFieldModule,
    MatSnackBarModule,
    MatDialogModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTableModule,
    MatPaginatorModule,
    MatExpansionModule,
    NgxMatSelectSearchModule,
    MatCheckboxModule,
    RecaptchaModule,
    MatRadioModule,
    NgOtpInputModule,
    IonicModule.forRoot(),
    MatDatepickerModule,
    MatNativeDateModule,
    MatSortModule,
    MatMenuModule,
    NgxMatSelectSearchModule,
    MatTabsModule,
    NgxChartsModule,
    GoogleChartsModule.forRoot(),
    NgxMatTimepickerModule,
    NgxMatDatetimePickerModule,
    NgxMatMomentModule,
    NgxChartsModule,
    GoogleChartsModule.forRoot(),
    PdfJsViewerModule,
    MatTooltipModule,
    FullCalendarModule,
    WebcamModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    DatePipe,
    InAppBrowser,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
